module.exports = __webpack_public_path__ + "img/close.cc44ce0d.svg";